module.exports = __webpack_public_path__ + "img/rect-layer2.afa31b1b.svg";